import { Div, Button } from '@codesuma/baseline'
import style from './index.module.css'

// Asked once, about an event in the phone's calendar that comes back every
// year. Emrouz can keep the same day in the Jalaali or the hijri calendar,
// where an anniversary belongs, instead of on a Gregorian date it drifts away
// from — so it offers, and either answer is final.
//
// Emits 'convert' to hand the event to the occasion wizard, or 'keep' to leave
// it alone for good. Tapping the backdrop is neither: it asks again another
// day.
export const AdoptDialog = (title: string) => {
    const base = Div()
    base.addClass(style.dialogBase)
    // Also what keeps a drag on it from pulling the sheet down (see pages/day).
    base.attr('role', 'dialog')

    const panel = Div()
    panel.addClass(style.dialogPanel)
    base.append(panel)

    const name = Div(title)
    name.addClass(style.dialogTitle)
    panel.append(name)

    const text = Div('این رویداد هر سال تکرار می‌شود. در تقویم شمسی یا قمری نگهش داریم؟')
    text.addClass(style.dialogText)
    panel.append(text)

    // Why it is worth saying yes. The whole difference is which calendar the
    // day is kept in, and that is not obvious from the question alone.
    const why = Div('تقویم گوشی آن را هر سال در همان تاریخ میلادی تکرار می‌کند.')
    why.addClass(style.dialogWhy)
    panel.append(why)

    const actions = Div()
    actions.addClass(style.dialogActions)
    panel.append(actions)

    const convert = Button('انتخاب تقویم')
    convert.addClass(style.dialogPrimary)
    convert.on('click', () => base.emit('convert'))
    actions.append(convert)

    const keep = Button('همین‌طور بماند')
    keep.addClass(style.dialogSecondary)
    keep.on('click', () => base.emit('keep'))
    actions.append(keep)

    base.on('click', (e: MouseEvent) => {
        if (e.target === base.el) base.emit('close')
    })

    return base
}
